import Api_Masterdata from '../api-masterdata'
import Api_Usermanagement from '../api-usermanagement'

const api = new Api_Usermanagement().init()
const apiMasterData = new Api_Masterdata().init()

const getFindocAll = (credential) => {
  return api.get(`/findoc?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const createFindoc = (data) => {
  return api.post(`/findoc/create`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const resubmitFindoc = (id, data) => {
  return api.post(`/findoc/resubmit/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetail = (id) => {
  return api.get(`/findoc/detail/${id}?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const approve = (id, data) => {
  return api.put(`/findoc/approve/${id}?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const reject = (id, note) => {
  return api.put(
    `/findoc/revision-reject/reject/${id}?credentials=${localStorage.getItem('credential')}`,
    note,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const updateValid = (id, data) => {
  return api.put(`/findoc/update/${id}?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const revision = (id, note) => {
  return api.put(
    `/findoc/revision-reject/revisi/${id}?credentials=${localStorage.getItem('credential')}`,
    note,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAccesses = (id) => {
  return api.get(`/role-access/detail/${id}/178`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const searchFindoc = (
  cred,
  status,
  inconterm,
  inconterm2,
  finNumb,
  findocType,
  findocName,
  skbdn,
  searchDate,
  searchDate2,
  sapNumber,
  sectorId,
  skpp,
  buyer,
  anper,
  created_at,
  tgl_findoc,
  negara_desc,
  currency,
  bank_name,
  nilai,
  allowance,
  resedual_value,
  top,
  valid_from_date,
  valid_to_date,
  latest_shipment_date
) => {
  return api.get(
    `/findoc?credentials=${cred}&status=${status}&incoterm=${inconterm}&incoterm2_id=${inconterm2}&findoc_number=${finNumb}&findoc_type=${findocType}&num_findoc=${findocName}&type_skbdn=${skbdn}&from_date=${searchDate}&to_date=${searchDate2}&sap_number=${sapNumber}&sector_id=${sectorId}&no_skpp=${skpp}&customer_name=${buyer}&sales_org_code=${anper}&created_at=${created_at}&tgl_findoc=${tgl_findoc}&negara_desc=${negara_desc}&currency=${currency}&bank_name=${bank_name}&nilai=${nilai}&allowance=${allowance}&resedual_value=${resedual_value}&top=${top}&valid_from_date=${valid_from_date}&valid_to_date=${valid_to_date}&latest_shipment_date=${latest_shipment_date}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getCustomer = (sales, dist, code, name) => {
  return apiMasterData.get(
    `/customer?sales_org_code=${sales}&distribution_channel=${dist}&customer_code=${code}&name=${name}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getBankKey = (name, branch, country) => {
  return apiMasterData.get(`/bank-key?bank_name=${name}&bank_branch=${branch}&country=${country}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getComment = (id) => {
  return api.get(`/findoc-comment/${id}/findoc?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const postComment = (lang, data) => {
  return api.post(`/findoc-comment/send/${lang}/findoc`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const syncFromSAP = (payload) => {
  return api.put('/findoc/sync', payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const sentToSAP = (id) => {
  return api.post(
    `/findoc/resend-to-sap/${id}?credentials=${localStorage.getItem('credential')}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const downloadSKPP = (skpp) => {
  return api.get(`/findoc/download-skpp/${skpp}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {
  getFindocAll,
  createFindoc,
  getDetail,
  reject,
  approve,
  revision,
  resubmitFindoc,
  searchFindoc,
  getCustomer,
  getAccesses,
  getBankKey,
  getComment,
  postComment,
  sentToSAP,
  updateValid,
  downloadSKPP,
  syncFromSAP,
}
